import React, { useEffect, useReducer, useRef  } from "react";

// Interface for country data
interface Country {
	ShortName: string;
}

// Interface for contacts data
interface Contacts {
	Address?: boolean;
	Linkedin?: boolean;
	Twitter?: boolean;
	Youtube?: boolean;
	Instagram?: boolean;
}

// Interface for preview table item
interface PreviewTableItem {
	domain: string;
	country: Country;
	rank: number;
	hidden: boolean;
	contacts: Contacts;
}

// Interface for component props
interface PreviewTableProps {
	progress: number;
	list?: PreviewTableItem[];
}

function _hideRank(hidden: boolean, rank: number): string | number {
	if (!hidden) return rank;

	return rank.toString().replace(/[0-9]/g, '*');
}

export const PreviewTable = ( props: PreviewTableProps ) => {

	return(
		<div className={"preview-table-wrap"}>
			<div className={ "preview-progress" + (props.progress >= 1 ? " hidden" : "") }
				 style={{ width: (props.progress * 100.0) + "%" }}
			>Loading...
			</div>
			<table className={"preview-table"}>
				<thead className={"preview-thead"}>
					<tr>
						<th>Domain</th>
						<th>Country</th>
						<th>Rank</th>
						<th>Contacts</th>
					</tr>
				</thead>
				<tbody className={"preview-tbody"}>
				{
					(props.list || []).map(( item: PreviewTableItem ) => {
						return (
							<tr key={ item.domain + ":" + item.country.ShortName }>
								{
									!item.hidden ? 
										<td className={"preview-tbody-cell"}>
											<div className={"preview-cell-wrap"}>
												<div className={ "preview-tbody-icon" }
													style={{ backgroundImage: "url( https://www.google.com/s2/favicons?domain=" + item.domain + " )" }}
												>{}</div>
												<a className={ "preview-tbody-d" } href={ "/website/" + item.domain }>{ item.domain }</a>
												<a className={ "preview-tbody-a" } href={ "http://" + item.domain } target="_blank" rel="noopener nofollow noreferrer"></a>
											</div>
										</td>
										:
										<td className={"preview-tbody-cell"}>
											<div className={"preview-cell-wrap"}>
												{ item.domain }
											</div>
										</td>
								}
								<td className={"preview-tbody-cell"}>
									<div className={"preview-cell-wrap  f-start"}>
										<div className={ "preview-tbody-icon" }
										   style={{ backgroundImage: "url( /s/ci/" + item.country.ShortName + ".png )" }}
										>{}</div>
										<div className={ "preview-tbody-d" }>{ item.country.ShortName }</div>
									</div>
								</td>

								<td className={"preview-tbody-cell"}>{ _hideRank(item.hidden, item.rank) }</td>

								<td className={"preview-tbody-cell"}>
									<div className={"preview-address" + (item.contacts[ "Address" ] ? "" : " hidden") }>{}</div>
									<div className={"preview-linkedin" + (item.contacts[ "Linkedin" ] ? "" : " hidden") }>{}</div>
									<div className={"preview-twitter" + (item.contacts[ "Twitter" ] ? "" : " hidden") }>{}</div>
									<div className={"preview-youtube" + (item.contacts[ "Youtube" ] ? "" : " hidden") }>{}</div>
									<div className={"preview-instagram" + (item.contacts[ "Instagram" ] ? "" : " hidden") }>{}</div>
								</td>

							</tr>
						);
					})
				}
				</tbody>
			</table>
		</div>
	);
};